import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardViewModel } from './dashboardModel';
import { VehicleProfile } from '../vehicle-profiles/vehicle-profiles.model';
import { API_BASE_URL } from '../core/api-base-url';

@Injectable({ providedIn: 'root' })
export class DashboardApiService {
  private readonly apiBaseUrl = API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getDashboard(ownerId = '', vehicleId?: number, refreshToken?: number): Observable<DashboardViewModel> {
    return this.http.post<DashboardViewModel>(`${this.apiBaseUrl}/api/dashboard/query`, {
      ownerId,
      vehicleId,
      seed: false,
      requestId: refreshToken
    });
  }

  updateVehicleMileage(ownerId: string, vehicleId: number, currentOdometerKm: number): Observable<VehicleProfile> {
    return this.http.put<VehicleProfile>(`${this.apiBaseUrl}/api/vehicleprofiles/${vehicleId}/mileage`, {
      ownerId: ownerId.trim(),
      currentOdometerKm
    });
  }
}
